import { useContext, useEffect, useState } from 'react';
import './ProgressDots.scss';
import { ReactComponent as YourSvg } from '../../_assets/img/check.svg';
import MainContext from '../../_helpers/Contexts/mainContext';
import { useHistory } from 'react-router-dom';

const ProgressDots2023_D2 = () => {
    const { step, setStep } = useContext(MainContext);
    const { ifManagerGlobal, setManagerGlobal } = useContext(MainContext);
    const history = useHistory();
    const [isD2, setIsD2] = useState(null);
    const [stepNames, setStepNames] = useState([
        ['step0', ['Start', 0, 'step', '/']],
        ['step1', ['Sposób złożenia', 1, 'step', '/step1']],
        ['step2', ['Dane podmiotu', 2, 'step', '/step2']],
        ['step3', ['Dane nieruchomości', 3, 'step', '/step3']],
        ['step31', ['Rodzaj działalności', 4, 'step', '/step31']],
        ['step4', ['Wysokość opłaty', 5, 'step', '/step44']],
        ['step5', ['Podsumowanie', 6, 'step', '/step5']]
    ]);

    const setProgressBar = (stepName) => {
        const matchIndex = (array) => array[0] === stepName;
        const matchIndexManager = (array) => array[0] === 'stepManager';
        let tempProgress = [...stepNames];
        let managerNumber = tempProgress.findIndex(matchIndexManager);
        if (ifManagerGlobal === true && managerNumber === -1) {
            tempProgress.push(['stepManager', ['Dane zarządcy', 2.1, 'step', '/stepManager']]);
        } else if (ifManagerGlobal === false && managerNumber > -1) {
            tempProgress.splice(managerNumber, 1);
        }
        sortArray(tempProgress);
        let stepNumber = tempProgress.findIndex(matchIndex);
 
        tempProgress.forEach((e, i) => {
            if (i < stepNumber) e[1][2] = 'is-complete';
            else if (i == stepNumber) e[1][2] = 'is-current';
            else if (i > stepNumber) e[1][2] = 'step';
        });
 
        setStepNames(tempProgress);
    };

    const setManager = () => {
        let localStorageData = localStorage.getItem('step2');
        if (localStorageData) {
            let data = JSON.parse(localStorageData);
            if (data) {
                if (data.ifManager == true) {
                    if (setManagerGlobal) {
                        setManagerGlobal(true);
                    }
                }
            }
        }
    };

    useEffect(() => {
        setManager();
        var step1Data = localStorage.getItem('step1');
        // if (step1Data) {
        //     var data = JSON.parse(step1Data);
        //     if (data.TypeD && data.TypeD === 1) {
        //         setIsD2(false);
        //     } else if (data.TypeD && data.TypeD === 2) {
        //         setIsD2(true);
        //     } else {
        //         setIsD2(false);
        //     }
        // }
    }, []);

    useEffect(() => {
        setProgressBar(step);
    }, [ifManagerGlobal]);

    const isStepLegit = (stepName) => {
        const matchIndex = (array) => array[0] === stepName;
        let stepNumber = stepNames.findIndex(matchIndex);

        if (stepName === 'stepManager') {
            return true;
        }

        if (stepNumber === -1) return false;
        else if (stepNumber === 0) return true;
        else if (stepNumber === 1) return true;
        else if (stepName === 'step5') {
            var localStorageData = localStorage.getItem('step4valid');
            if (localStorageData === 'true') return true;
        } else if (stepNumber > 1) {
            let previousStep = stepNames[stepNumber - 1];
 
            var localStorageData = localStorage.getItem(previousStep[0]);
            if (localStorageData && localStorageData.length > 0) {
                const data = JSON.parse(localStorageData);
                if (data.valid === true) return true;
            }
        }
        return false;
    };

    const sortArray = (items) => {
        items.sort(function (first, second) {
            if (first && second) return second[1][1] - first[1][1];
            else return null;
        });
        items.reverse();
    };

    useEffect(() => {
        if (step) {
            if (step === 'step31') {
                setProgressBar('TypeOfActivitySection');
            } else if (!isStepLegit(step)) {
                history.push({
                    pathname: '/',
                    state: { new: false, fromLocalStorage: true }
                });
            }

            setProgressBar(step);
        }
    }, [step]);

    return (
        <>
            <div className="wrapper">
                <div className="TitleCategory">Postęp</div>

                <ol className="ProgressBar" id="ProgressBar">
                    {stepNames.map(function (object, i) {
                        return (
                            <li
                                key={stepNames[i][0]}
                                className={'ProgressBar-step ' + stepNames[i][1][2]}
                                onClick={() => {
                                    if (isStepLegit(stepNames[i][0]) && stepNames[i][1][2] === 'is-complete') {
                                        history.push({
                                            pathname: '.' + stepNames[i][1][3],
                                            state: { new: false, fromLocalStorage: true }
                                        });
                                    }
                                }}
                            >
                                <YourSvg className="ProgressBar-icon" /> <span className="ProgressBar-stepLabel">{stepNames[i][1][0]}</span>
                            </li>
                        );
                    })}
                </ol>
            </div>
        </>
    );
};

export { ProgressDots2023_D2 };
